import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { GarageEntity, GarageRequestEntity } from 'src/entities/garageEntity';

export const useMutationGarage = () => {
  const queryClient = useQueryClient();
  return {
    addGarage: useMutation(
      (driver: GarageRequestEntity) => axios.post('/api/v2/garages', driver),
    ),
    updateGarage: useMutation(
      (driver: GarageEntity) => axios.put(`/api/v2/garages/${driver.id}`, driver),
    ),
    deleteGarages: useMutation(
      (ids: number[]) => axios.delete('/api/v2/garages/bulk', { data: { ids } }),
      {
        onSuccess: () => {
          // eslint-disable-next-line no-void
          void queryClient.invalidateQueries(['trucks']);
          // eslint-disable-next-line no-void
          void queryClient.invalidateQueries(['drivers']);
        }
      }
    )
  };
};
